var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4808 12.6916C25.6867 12.605 25.9121 12.5751 26.1335 12.6051C26.355 12.6351 26.5643 12.7239 26.7397 12.8622C26.9152 13.0006 27.0503 13.1834 27.1311 13.3917C27.2119 13.6 27.2354 13.8262 27.1991 14.0466L25.3091 25.5108C25.1258 26.6166 23.9125 27.2508 22.8983 26.7C22.05 26.2391 20.79 25.5291 19.6566 24.7883C19.09 24.4175 17.3541 23.23 17.5675 22.385C17.7508 21.6625 20.6675 18.9475 22.3341 17.3333C22.9883 16.6991 22.69 16.3333 21.9175 16.9166C19.9991 18.365 16.9191 20.5675 15.9008 21.1875C15.0025 21.7341 14.5341 21.8275 13.9741 21.7341C12.9525 21.5641 12.005 21.3008 11.2316 20.98C10.1866 20.5466 10.2375 19.11 11.2308 18.6916L25.4808 12.6916Z",
    fill: "#0B0B0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgIcon);
export default __webpack_public_path__ + "static/media/tg-icon.daf059cce98b3816ccdc9207399cb9d4.svg";
export { ForwardRef as ReactComponent };